import { Button, Dropdown, Row } from 'antd'
import { useState } from 'react'

const DropdownFilter = ({
	children,
	handleGetData,
	handleResetFilter,
	totalFilter = null,
	fullsize,
	onOpenChange,
	open,
}) => {
	const [isOpen, setIsOpen] = useState(false)

	const filterList = (
		<div
			style={{
				backgroundColor: '#fff',
				boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
				borderRadius: 12,
				padding: 16,
				width: 250,
			}}
		>
			<div
				style={{
					borderBottom: '1px solid #F5F5F5',
					paddingBottom: 12,
				}}
			>
				<span
					style={{
						fontSize: 14,
						fontWeight: 600,
					}}
				>
					Tùy chọn bộ lọc
				</span>
			</div>
			<Row
				gutter={[0, 16]}
				style={{
					display: 'flex',
					flexDirection: 'column',
					padding: '16px 0',
				}}
			>
				{children}
			</Row>
			{!!handleGetData && (
				<div className="dropdown-filter__btn-wrapper">
					<Button onClick={() => handleResetFilter()}>Đặt lại bộ lọc</Button>
					<Button type="primary" onClick={() => handleGetData()}>
						Hoàn tất
					</Button>
				</div>
			)}
		</div>
	)

	return (
		<Dropdown
			overlay={filterList}
			trigger={['click']}
			placement="bottomRight"
			onOpenChange={(open) => {
				if (onOpenChange) {
					onOpenChange()
				} else {
					setIsOpen(open)
				}
			}}
			open={open ? open : isOpen}
		>
			<div
				style={{
					padding: '8px 16px',
					cursor: 'pointer',
					backgroundColor: isOpen ? '#fff' : '#F5F5F5',
					width: fullsize ? '100%' : 120,
					color: isOpen ? '#cc0000' : '#181C32',
					boxShadow: isOpen ? '0px 4px 30px rgba(0, 0, 0, 0.1)' : '',
					fontSize: 16,
				}}
			>
				Bộ lọc ({totalFilter || children.length})
			</div>
		</Dropdown>
	)
}

export default DropdownFilter
